




















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

declare var cv: any;

@Component({})
export default class JudgmentResult extends Vue {
  @Prop()
  imageFile?: File;

  inputCanvas?: HTMLCanvasElement;
  outputCanvas?: HTMLCanvasElement;

  isCompleted: boolean = false;

  result?: string = "";

  async mounted() {
    this.inputCanvas = this.$refs.inputCanvas as HTMLCanvasElement;
    this.outputCanvas = this.$refs.outputCanvas as HTMLCanvasElement;

    await this.drawInputImage(this.imageFile as File);

    this.convertGreyScale();

    const average = this.calcAverage();

    setTimeout(() => {
      this.result = this.judge(average);
      this.isCompleted = true;
      this.$emit("judgeCompleted");
    }, 1000);
  }

  async drawInputImage(imageFile: File) {
    return new Promise((resolve, reject) => {
      if (!this.inputCanvas || !this.outputCanvas) return;

      const ctx = this.inputCanvas.getContext("2d") as CanvasRenderingContext2D;
      const img = new Image();
      img.onload = () => {
        if (!this.inputCanvas || !this.outputCanvas) return;
        this.inputCanvas.width = this.outputCanvas.width = img.width;
        this.inputCanvas.height = this.outputCanvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);
        resolve();
      };
      img.src = URL.createObjectURL(imageFile);
    });
  }

  convertGreyScale() {
    const src = cv.imread(this.inputCanvas);
    const dst = new cv.Mat();
    cv.cvtColor(src, dst, cv.COLOR_RGBA2GRAY);
    cv.imshow(this.outputCanvas, dst);
    src.delete();
    dst.delete();
  }

  calcAverage(): number {
    const src = cv.imread(this.outputCanvas);
    const dst = new cv.Mat();
    const dsize = new cv.Size(1, 1);
    cv.resize(src, dst, dsize, 0, 0, cv.INTER_AREA);
    cv.cvtColor(dst, dst, cv.COLOR_BGR2HSV);
    return dst.data[2];
  }

  judge(average: number) {
    // グレースケールの画像を読み込む
    const src = cv.imread(this.outputCanvas);
    const dst = new cv.Mat();

    // 色空間をHSVに変換
    cv.cvtColor(src, dst, cv.COLOR_BGR2HSV);

    // 色相、彩度、明度ごとに切り出す
    const hsvVector = new cv.MatVector();
    cv.split(dst, hsvVector);
    // 明度のMatのみを取得する
    const brightnessMat = hsvVector.get(2);

    // 平均値を基準に各画素の分散を求める
    const differences = {
      black: new Array<number>(),
      white: new Array<number>()
    };
    (brightnessMat.data as Array<number>).forEach(d => {
      const diff = Math.pow(average - d, 2);
      if (d > average) differences.white.push(diff);
      else if (d < average) differences.black.push(diff);
    });

    // black、whiteそれぞれの分散を求める
    const calcAverage = (array: number[]) => {
      return array.reduce((p, c) => p + c, 0) / array.length;
    };
    const blackAverage = calcAverage(differences.black);
    const whiteAverage = calcAverage(differences.white);

    // 分散が大きい方を結果として返す
    if (blackAverage > whiteAverage) return "Black";
    else if (blackAverage < whiteAverage) return "White";
    else return "Gray";
  }

  average(array: number[]) {
    return array.reduce((p, c) => p + c, 0) / array.length;
  }

  retry() {
    this.$emit("retry");
  }
}
